export const ROUTES = {
    HOME: '/',
    LOGIN: '/login',
    DASHBOARD: '/dashboard',
    OFFER_ROOM: '/offer-room',
    USERS: '/users',
    ANALYTICS: '/analytics',
    COMPARE_CAMPAIGN: '/compare-campaign',
    DPC: '/dpc',
    SETTINGS: '/settings',
    PRODUCTS: '/product-base',
    SERVICE_TEMPLATES: '/settings/service-templates',
    CONTACT_FORM_SETTINGS: '/settings/contact-form-settings',
    ACCESS_DENIED: '/access-denied',
    PRODUCT_IMPORT: '/product-base/import',
};
